import NavBar from "../../Navbar/Navbar";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { setEnvironmentColors } from "../../Utils/EnvironnementColor";
import "./Environnement.css";

const Environnement = () => {
  const groupsCookie = Cookies.get("groups");
  const groups = groupsCookie ? JSON.parse(groupsCookie) : [];
  const navigate = useNavigate();

  const role = Cookies.get("Role");

  const [headerColor, setHeaderColor] = useState("#235073");
  const [colorFilter, setColorFilter] = useState("#235073");

  const handleSelectGroup = async (group) => {
    const env = group.split("-")[1].toUpperCase();
    Cookies.set("Env", env);

    const apiMap = {
      DEMO: "https://api-demo.myactivhub.net",
      DEV: "https://api-dev.myactivhub.net",
      PROD: "https://api-prod.myactivhub.net",
      IMFDEV: "https://api-imfdev.myactivhub.net",
      IMFPROD: "https://api-imfprod.myactivhub.net",
      LUMDEV: "https://api-lumdev.myactivhub.net",
      LUMPROD: "https://api-lumprod.myactivhub.net",
    };

    const apiBaseUrl = apiMap[env];
    Cookies.set("ApiUrl", apiBaseUrl);

    if (role === "superadmin") {
      navigate("/Admin");
    } else {
      navigate("/User");
    }
  };

  useEffect(() => {
    setEnvironmentColors([
      [setHeaderColor, "headerColor"],
      [setColorFilter, "colorFilter"],
    ]);
  }, []);

  return (
    <>
      <NavBar />
      <div id="dashboard">
        <div className="main-card">
          <table>
            <thead style={{ backgroundColor: colorFilter }}>
              <tr>
                <th>List Environnement :</th>
              </tr>
            </thead>
            <tbody>
              {groups.map((group, index) => (
                <tr key={index}>
                  <td>
                    <span
                      className="clickable"
                      onClick={() => handleSelectGroup(group)}
                    >
                      {group}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default Environnement;
